export type UploadTransfer = {phase:'uploading'|'processing';percent:number|null};
/** One same-origin binary request. Progress is observed, never a retry or a timer estimate. */
export function uploadRequest(path:string,data:Blob,headers:Headers,onProgress:(progress:UploadTransfer)=>void,signal?:AbortSignal|null,create:()=>XMLHttpRequest=()=>new XMLHttpRequest()):Promise<Response>{
 const url=new URL(path,location.href);
 if(url.origin!==location.origin||url.username||url.password)return Promise.reject(new Error('Загрузка разрешена только в этот чат.'));
 return new Promise((resolve,reject)=>{
  const xhr=create();let settled=false;
  const finish=(error?:unknown,response?:Response)=>{if(settled)return;settled=true;signal?.removeEventListener('abort',abort);if(error)reject(error);else resolve(response!);};
  const abort=()=>{finish(signal?.reason??new DOMException('Загрузка отменена','AbortError'));xhr.abort();};
  if(signal?.aborted){abort();return;}
  xhr.open('PUT',url.href);headers.forEach((value,name)=>xhr.setRequestHeader(name,value));
  xhr.upload.onprogress=event=>{
   if(settled)return;
   onProgress({phase:'uploading',percent:event.lengthComputable&&event.total>0?Math.min(100,Math.max(0,Math.floor(event.loaded/event.total*100))):null});
  };
  xhr.upload.onload=()=>{if(!settled)onProgress({phase:'processing',percent:100});};
  xhr.onload=()=>{
   if(xhr.status===0){finish(new Error('Соединение прервалось. Файл не подтверждён сервером.'));return;}
   try{finish(undefined,new Response([204,205,304].includes(xhr.status)?null:xhr.responseText,{status:xhr.status,headers:{'Content-Type':xhr.getResponseHeader('Content-Type')??'application/json'}}));}
   catch(error){finish(error);}
  };
  xhr.onerror=()=>finish(new Error('Соединение прервалось. Файл не подтверждён сервером.'));
  xhr.onabort=()=>finish(new DOMException('Загрузка отменена','AbortError'));
  signal?.addEventListener('abort',abort,{once:true});
  onProgress({phase:'uploading',percent:0});xhr.send(data);
 });
}
